import { transformToCartItem } from '@/models/blue/CartItem';
export function transformToCart(data) {
    const cart = Object.assign({}, data);
    cart.products.forEach(function (cart_item, index, list) {
        list[index] = transformToCartItem(cart_item);
    });
    return cart;
}
